export default "__VITE_ASSET__fbda6320__"